import React, { useEffect } from 'react';
import { Box, Typography, TextField, Stack } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
// import { PreferenceButton } from './PreferenceButton';
// import { AdditionalInfo } from './AdditionalPreference';
import { RootState } from '../../../../core/store';
import { useSelector } from 'react-redux';
import PartnerAutocomplete from '../PartnerAutocomplete';

interface PreferenceInformationStepProps {
  isSaving?: boolean;
}

const PreferenceInformationStep: React.FC<PreferenceInformationStepProps> = ({ isSaving = false }) => {
  // const [sharePreferences, setSharePreferences] = useState<string>('No');

  const preferenceInformation = useSelector((state: RootState) => state.preferenceInformation);
  const {
    control,
    formState: { errors },
    reset,
    setValue,
    // watch,
  } = useFormContext();

  // useEffect(() => {
  //   const hasPreferenceValues = 
  //     (preferredCoachGenders && preferredCoachGenders !== '') || 
  //     (preferredCoachEthnicities && preferredCoachEthnicities.length > 0) || 
  //     (preferredCoachSexualOrientations && preferredCoachSexualOrientations !== '') || 
  //     (additionalInformation && additionalInformation !== '');
    
  //   if (hasPreferenceValues && sharePreferences === 'No') {
  //     setSharePreferences('Yes');
  //   }
  // }, [
  //   preferredCoachGenders, 
  //   preferredCoachEthnicities, 
  //   preferredCoachSexualOrientations, 
  //   additionalInformation, 
  //   sharePreferences
  // ]);

  // useEffect(() => {
  //   if (sharePreferences === 'No') {
  //     setValue('preferredCoachGenders', '');
  //     setValue('preferredCoachEthnicities', []);
  //     setValue('preferredCoachSexualOrientations', '');
  //     setValue('additionalInformation', '');
  //   }
  // }, [sharePreferences, setValue]);

  useEffect(() => {
    if (!preferenceInformation) return;

    let isInitialRender = true;

    if (isInitialRender) {
      reset(
        {
          hopeToGain: preferenceInformation.hopeToGain || '',
          preferredPartnerId: preferenceInformation.preferredPartnerId || null,
          preferredPartnerName: preferenceInformation.preferredPartnerName || null,
          // preferredCoachGenders: coachPreferences.preferredCoachGenders || '',
          // preferredCoachEthnicities: coachPreferences.preferredCoachEthnicities || [],
          // preferredCoachSexualOrientations: coachPreferences.preferredCoachSexualOrientations || '',
         // additionalInformation: preferenceInformation.additionalInformation || '',
        },
        { keepDefaultValues: true }
      );
      isInitialRender = false;
    }
  }, [
    preferenceInformation?.hopeToGain,
    preferenceInformation?.preferredPartnerId,
    preferenceInformation?.preferredPartnerName,
    // preferenceInformation?.additionalInformation,
    // coachPreferences?.preferredCoachGenders,
    // coachPreferences?.preferredCoachEthnicities,
    // coachPreferences?.preferredCoachSexualOrientations,
    reset]);

  return (
    <Box sx={{ mt: { xs: 0, sm: 2 } }}>
      <Typography variant='h5' color='text.primary' sx={{ mb: { xs: 1, sm: 3 } }}>
        Additional Information (Optional)
      </Typography>

      <Stack spacing={{ xs: 1, sm: 4 }}>
        <Box>
          {/* <Typography variant='body1' sx={{ mb: 2 }}>
            Would you like to share preferences for your coach?
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <PreferenceButton
              value='Yes'
              currentValue={sharePreferences}
              onClick={() => setSharePreferences('Yes')}
            />
            <PreferenceButton
              value='No'
              currentValue={sharePreferences}
              onClick={() => setSharePreferences('No')}
            />
          </Box> */}

          <Typography variant='body1' sx={{ mb: { xs: 1, sm: 2 } }}>
            What do you hope to gain by texting MindRight?
          </Typography>
          <Controller
            name='hopeToGain'
            control={control}
            render={({ field }) => (
              <TextField
                fullWidth
                label="Share any challenges you're facing, topics you want to discuss, preferred personality traits, etc."
                {...field}
                value={field.value || ''}
                variant='outlined'
                multiline
                rows={3}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                    style: { 
                      whiteSpace: 'normal',
                      maxWidth: '100%',
                      lineHeight: 1.2
                    } 
                  }
                }}
                sx={{
                  '.MuiOutlinedInput-root': {
                    backgroundColor: 'background.paper',
                  },
                  '.MuiFormLabel-root': {
                    overflow: 'visible',
                    lineHeight: 1.2,
                    paddingTop: { xs: '4px', sm: 0 },
                  },
                  mb: { xs: 2, sm: 4 },
                  mt: { xs: 1, sm: 0 }
                }}
                disabled={isSaving}
                error={Boolean(errors.hopeToGain)}
              />
            )}
          />

          <Box sx={{ mt: { xs: 2, sm: 3 } }}>
            <Controller
              name='preferredPartnerId'
              control={control}
              render={({ field: { value: partnerId, onChange: onPartnerIdChange } }) => {
                // const partnerName = watch('preferredPartnerName');
                return (
                  <PartnerAutocomplete
                    value={partnerId || null}
                    onChange={(id, name) => {
                      onPartnerIdChange(id || null);
                      setValue('preferredPartnerName', name || null);
                    }}
                    disabled={isSaving}
                    error={Boolean(errors.preferredPartnerId)}
                    helperText={errors.preferredPartnerId?.message?.toString()}
                  />
                );
              }}
            />
          </Box>

          {/* {sharePreferences === 'Yes' && <AdditionalInfo isSaving={isSaving} />} */}
        </Box>
      </Stack>
    </Box>
  );
};

export default React.memo(PreferenceInformationStep);
